import React from 'react'
import { Contractor } from 'classes';
import { getProjectContractors, deleteContractor } from 'utils/ContractorsUtils';
import { useAppContext } from 'hooks/useAppContext';
import Grid from 'components/Custom/Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';

export default function Contractors() {
  const columns = Contractor.columns
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Contractors"
  const getFormPath = () => import('components/Contractors/AddContractors');

  return (
    selectedProject ?
      <Grid
        columns={columns}
        title={title}
        getRecords={getProjectContractors}
        deleteRecord={deleteContractor}
        selectedProject={selectedProject}
        component="Contractors"
        formPath={getFormPath}
        options={{
          pageSize: 10,
          pageSizeOptions: [10, 20, 25]
        }}
      /> : <SkeletonGrid title={title} />
  )
}